import script from "./test-registration-status.vue?vue&type=script&setup=true&lang=js"
export * from "./test-registration-status.vue?vue&type=script&setup=true&lang=js"

import "./test-registration-status.vue?vue&type=style&index=0&id=4c3c7f4d&lang=css"

const __exports__ = script;

export default __exports__